var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToolIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 31.8111 31.8119",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 31.811066,
    height: 31.81189,
    fill: "none",
    customFrame: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint_linear_1",
    x1: 31.311058,
    x2: 0.499996185,
    y1: 0.499962807,
    y2: 31.3118515,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(91,127,216)",
    offset: 0,
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "rgb(155,88,204)",
    offset: 1,
    stopOpacity: 1
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84 41035",
    d: "M5.57122 17.055L8.54022 20.0257L10.8401 17.7259L7.86781 14.7585L10.1644 12.4618L13.1351 15.4309L15.4316 13.1343L12.4643 10.1636L14.7608 7.867L17.7267 10.8393L20.0249 8.54105L17.0543 5.57201L21.6491 0.978821C22.2833 0.34478 23.3114 0.34478 23.9457 0.978821L30.8355 7.86863C31.4696 8.50288 31.4696 9.53097 30.8355 10.1652L10.1644 30.8363C9.53017 31.4704 8.50204 31.4704 7.86781 30.8363L0.977982 23.9465C0.343948 23.3123 0.343948 22.2842 0.977982 21.6499L5.57118 17.055L5.57122 17.055ZM19.3525 26.2415L26.2439 19.3517L30.5253 23.633L30.5253 30.5245L23.6355 30.5245L19.3525 26.2415ZM5.57118 12.4602L0.976349 7.867C0.671356 7.56235 0.5 7.14896 0.5 6.7179C0.5 6.28682 0.671356 5.87342 0.976349 5.56878L5.57122 0.97554C6.20547 0.341484 7.23359 0.341484 7.86784 0.97554L12.4643 5.56878L5.57118 12.4602L5.57118 12.4602Z",
    fill: "url(#paint_linear_1)",
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "\\u8DEF\\u5F84 41035",
    d: "M8.54022 20.0257L10.8401 17.7259L7.86781 14.7585L10.1644 12.4618L13.1351 15.4309L15.4316 13.1343L12.4643 10.1636L14.7608 7.867L17.7267 10.8393L20.0249 8.54105L17.0543 5.57201L21.6491 0.978821C22.2833 0.34478 23.3114 0.34478 23.9457 0.978821L30.8355 7.86863C31.4696 8.50288 31.4696 9.53097 30.8355 10.1652L10.1644 30.8363C9.53017 31.4704 8.50204 31.4704 7.86781 30.8363L0.977982 23.9465C0.343948 23.3123 0.343948 22.2842 0.977982 21.6499L5.57118 17.055L5.57122 17.055L8.54022 20.0257ZM26.2439 19.3517L30.5253 23.633L30.5253 30.5245L23.6355 30.5245L19.3525 26.2415L26.2439 19.3517ZM0.976349 7.867C0.671356 7.56235 0.5 7.14896 0.5 6.7179C0.5 6.28682 0.671356 5.87342 0.976349 5.56878L5.57122 0.97554C6.20547 0.341484 7.23359 0.341484 7.86784 0.97554L12.4643 5.56878L5.57118 12.4602L5.57118 12.4602L0.976349 7.867Z",
    fillRule: "nonzero",
    stroke: "rgb(112,112,112)",
    strokeOpacity: 0,
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolIcon);
export default __webpack_public_path__ + "static/media/toolIcon.9a22e17d17f9053021084d1534cd9603.svg";
export { ForwardRef as ReactComponent };